import type { Network } from '@mogul/api-client';

import {
  ContractAddress,
  ContractAddressRinkeby,
} from '../constants/contract.constants';

export const getContractName = (address: string) => {
  for (const [name, _address] of Object.entries(ContractAddress)) {
    if (_address === address) {
      return name;
    }
  }

  for (const [name, _address] of Object.entries(ContractAddressRinkeby)) {
    if (_address === address) {
      return name;
    }
  }
};

export const getContractNetwork = (address: string) => {
  if ((Object.values(ContractAddress) as string[]).includes(address)) {
    return 'mainnet';
  }

  if ((Object.values(ContractAddressRinkeby) as string[]).includes(address)) {
    return 'rinkeby';
  }
};

export const getEtherscanUrl = (
  address: string,
  collectionNetwork?: Network,
) => {
  const network = getContractNetwork(address) ?? collectionNetwork;

  return `https://${
    network !== undefined && network !== 'mainnet' ? `${network}.` : ''
  }etherscan.io/address/${address}`;
};

export const getOpenseaUrl = (address: string, id: string) => {
  const network = getContractNetwork(address);

  return `https://${
    network !== undefined && network !== 'mainnet' ? 'testnets.' : ''
  }opensea.io/assets/${address}/${id}`;
};
